export class CargoTankTemperature {
    cargoNumber: string;
    commodityId: number;
    tankId: number;
    tankName?: string;
    isOnBoard: boolean;
    isInhibitedCargo: boolean;
    isCooledCargo: boolean;
    isHeatedCargo: boolean;
    tradeName?: string;
    temperature?: number;
    cargoLoadingTemperature?: number;

    constructor(
        cargoNumber: string,
        commodityId: number,
        tankId: number,
        isOnBoard: boolean,
        isInhibitedCargo: boolean,
        isCooledCargo: boolean,
        isHeatedCargo: boolean,
        tradeName?: string,
        temperature?: number,
        cargoLoadingTemperature?: number
    ) {
        this.cargoNumber = cargoNumber;
        this.commodityId = commodityId;
        this.tankId = tankId;
        this.isOnBoard = isOnBoard;
        this.isInhibitedCargo = isInhibitedCargo;
        this.isCooledCargo = isCooledCargo;
        this.isHeatedCargo = isHeatedCargo;
        this.tradeName = tradeName;
        this.temperature = temperature;
        this.cargoLoadingTemperature = cargoLoadingTemperature;
    }
}
